<template>
  <div>
    <div v-if="!isLoading">
      <el-card
        class="crm-branch-card"
        :class="branchInfo.disabledFlag? 'cursor-not-allowed' : 'cursor-allowed'"
        @click.native="!branchInfo.disabledFlag && gotoBranch()"
      >
        <div class="d-flex crm-branch-item">
          <el-image
            class="crm-branch-img"
            fit="cover"
            :src="
              branchInfo.logoImgKey
                ? `${S3PublicPath}${branchInfo.logoImgKey}`
                : require('@/assets/img/no-branch-img.png')
            "
          />
          <div class="crm-branch-info mx-4">
            <div class="header-name-branch">
              <div class="text-1-line name-branch">{{ branchInfo.branchName }}</div>
              <div class="bubble-branch-close" v-if="branchInfo.disabledFlag" > {{$t("branch.close-branch")}}</div> 
            </div>
            <p v-if="branchInfo.address" class="my-0 text-1-line">
              <i class="el-icon-location-outline"></i> {{ branchInfo.address }}
            </p>
          </div>
          <div class="crm-branch-icon">
            <svg-arrow-right-gray-circle v-if="branchInfo.disabledFlag"/>
            <svg-arrow-right-circle v-else/>
          </div>
        </div>
      </el-card>
    </div>
    <div v-else>
      <el-card class="crm-branch-card">
        <el-skeleton animated>
          <template slot="template">
            <div class="d-flex crm-branch-item">
              <el-skeleton-item variant="image" class="crm-branch-img" />
              <div class="crm-branch-info mx-4">
                <el-skeleton-item variant="text" style="width: 10em" />
                <el-skeleton-item variant="text" style="width: 50%" />
              </div>
            </div>
          </template>
        </el-skeleton>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const SvgArrowRightCircle = () => import("@/assets/svg/arrow-right-circle.svg");
const SvgArrowRightGrayCircle = () => import("@/assets/svg/arrow-right-circle-gray.svg");

export default {
  name: "BranchList",
  components: {
    SvgArrowRightCircle,
    SvgArrowRightGrayCircle
  },
  props: {
    isLoading: Boolean,
    branchInfo: Object,
  },
  data() {
    return {
      S3PublicPath: process.env.VUE_APP_S3_PUBLIC_PATH,
    };
  },
  methods: {
    gotoBranch() {
      window.location.href = `/${this.restaurantUUID}/${this.branchInfo.branchUUID}`;
    },
  },
  computed: {
    ...mapGetters({
      restaurantUUID: "restaurant/restaurantUUID",
    }),
  },
};
</script>

<style scoped>
.crm-branch-card {
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.07);
}

.crm-branch-img {
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  border-radius: 8px;
}

.crm-branch-item {
  align-items: center;
}

.crm-branch-info {
  min-width: 0;
}

.crm-branch-info h1 {
  color: var(--gray-1);
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}

.crm-branch-info p {
  color: var(--gray-2);
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
}

.crm-branch-icon-location-outline {
  width: 12px;
  height: 12px;
}

.crm-branch-icon {
  width: 28px;
  height: 28px;
  margin-left: auto;
  text-align: center;
}
.el-button.is-circle {
    border-radius: 50% !important;
    padding: 12px;
}
.header-name-branch{
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  width: 100%;
}
.name-branch{
  font-size: 16px;
  /* max-width: calc(100% - 55px); */
}
.bubble-branch-close{
  background: #FE5F55;
  border-radius: 53px;
  color: #fff;
  height: 16px;
  width: fit-content;
  padding: 1px 8px 2px;
  margin-left: 8px;
  min-width: 45px;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-allowed{
  cursor: pointer;
}
</style>